import { QueryDraftPostsCountArgs } from '@tribeplatform/gql-client/types'

import { UseQueryOptions, useQuery } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getDraftPostsCountKey } from '../../utils/keys/post.key.js'

export const useDraftPostsCount = (options: {
  variables: QueryDraftPostsCountArgs
  useQueryOptions?: UseQueryOptions<number>
}) => {
  const { variables, useQueryOptions } = options || {}
  const { client } = useTribeClient()
  const postsKey = getDraftPostsCountKey({
    variables: { ...variables },
  })

  return useQuery<number>(
    postsKey,
    () => client?.posts.draftPostsCount({ ...variables }),
    useQueryOptions,
  )
}
